import React, {
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react";
import { Modal } from "react-bootstrap";
import axios from "axios";
import { FaBookOpen, FaCheck, FaSearch, FaTimes } from "react-icons/fa";
import SessionManager from "../Utils/SessionManager";
import myToast from "../Utils/MyToast";
import "../css/Admin_css/admin-customize.css";

const API_BASE = () =>
  `${process.env.REACT_APP_SERVER_NAME}${process.env.REACT_APP_TARGET_DIR}`;

const MODAL_RADIUS = 16;

const DIALOG_STYLES = `
  .modal.show { display: block !important; opacity: 1 !important; }
  .modal.fade.show { opacity: 1 !important; }
  .mdl-add-subject-dialog.modal-dialog {
    z-index: 1050 !important;
    position: relative;
    margin: 0.45rem auto 1rem;
    max-width: 760px;
  }
  .mdl-add-subject-dialog.modal-dialog.modal-dialog-centered {
    min-height: calc(100% - 1rem);
  }
  .modal-backdrop { z-index: 1040 !important; }
  .modal-backdrop.show { opacity: 0.5 !important; }
  .mdl-add-subject-dialog .modal-content {
    z-index: 1051 !important;
    position: relative;
    border-radius: ${MODAL_RADIUS}px;
    overflow: hidden;
    border: 2px solid rgba(179, 229, 252, 0.55);
    box-shadow: 0 12px 28px rgba(2, 136, 209, 0.14);
    background: #fff;
  }
  .mdl-add-subject-dialog .modal-header {
    border: none;
    padding: 12px 16px;
    background: linear-gradient(135deg, #03a9f4 0%, #0288d1 55%, #01579b 100%);
  }
  .mdl-add-subject-dialog .modal-header .close {
    color: #fff;
    opacity: 0.92;
    text-shadow: none;
    font-size: 1.35rem;
    font-weight: 400;
    padding: 0.35rem 0.55rem;
  }
  .mdl-add-subject-dialog .modal-body {
    padding: 12px 14px 10px;
    background: linear-gradient(180deg, #f7fcff 0%, #ffffff 42%);
  }
  .mdl-add-subject-dialog .modal-footer {
    border-top: 1px solid #e1f5fe;
    padding: 10px 14px;
    background: #f0f9ff;
    display: flex;
    justify-content: flex-end;
    gap: 8px;
  }
  .mas-title {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    margin: 0;
    color: #fff;
    width: 100%;
    padding-right: 18px;
  }
  .mas-title__icon {
    width: 34px;
    height: 34px;
    border-radius: 10px;
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: rgba(255,255,255,0.18);
    border: 1px solid rgba(255,255,255,0.35);
    font-size: 15px;
  }
  .mas-title__text { min-width: 0; }
  .mas-title__main {
    font-size: 16px;
    font-weight: 800;
    line-height: 1.2;
  }
  .mas-title__sub {
    margin-top: 2px;
    font-size: 11px;
    font-weight: 500;
    color: rgba(255,255,255,0.88);
    line-height: 1.3;
  }
  .mas-meta {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-bottom: 10px;
  }
  .mas-pill {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    min-height: 26px;
    padding: 3px 10px;
    border-radius: 999px;
    border: 1px solid #b3e5fc;
    background: #e1f5fe;
    color: #01579b;
    font-size: 11px;
    font-weight: 700;
  }
  .mas-search {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 10px;
    padding: 0 10px;
    min-height: 38px;
    border-radius: 10px;
    border: 2px solid rgba(179, 229, 252, 0.7);
    background: #fff;
  }
  .mas-search svg {
    color: #0288d1;
    font-size: 13px;
    flex-shrink: 0;
  }
  .mas-search input {
    flex: 1;
    border: none;
    outline: none;
    background: transparent;
    min-height: 34px;
    font-size: 13px;
    color: #37474f;
    font-weight: 600;
  }
  .mas-search input::placeholder {
    color: #90a4ae;
    font-weight: 500;
  }
  .mas-list {
    max-height: 320px;
    overflow-y: auto;
    display: grid;
    gap: 8px;
    padding: 2px;
  }
  .mas-item {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    text-align: left;
    padding: 10px 12px;
    border-radius: 10px;
    border: 2px solid rgba(179, 229, 252, 0.65);
    background: #fff;
    cursor: pointer;
    transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;
  }
  .mas-item:hover {
    border-color: #4fc3f7;
    background: #f0f9ff;
  }
  .mas-item.is-active {
    border-color: #0288d1;
    background: #e1f5fe;
    box-shadow: 0 2px 8px rgba(2, 136, 209, 0.1);
  }
  .mas-item__check {
    width: 22px;
    height: 22px;
    border-radius: 999px;
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: 2px solid #b3e5fc;
    background: #fff;
    color: transparent;
    font-size: 10px;
  }
  .mas-item.is-active .mas-item__check {
    border-color: #0288d1;
    background: #0288d1;
    color: #fff;
  }
  .mas-item__body { min-width: 0; flex: 1; }
  .mas-item__name {
    font-size: 13px;
    font-weight: 800;
    color: #01579b;
    line-height: 1.25;
  }
  .mas-item__code {
    margin-top: 2px;
    font-size: 11px;
    font-weight: 600;
    color: #607d8b;
  }
  .mas-empty {
    text-align: center;
    padding: 28px 12px;
    border-radius: 10px;
    border: 2px dashed rgba(179, 229, 252, 0.7);
    background: #f8fcff;
  }
  .mas-empty__title {
    margin: 0;
    font-size: 14px;
    font-weight: 800;
    color: #455a64;
  }
  .mas-empty__hint {
    margin: 4px 0 0;
    font-size: 12px;
    color: #78909c;
  }
  .mas-selected {
    margin-top: 10px;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 6px 10px;
    border-radius: 999px;
    border: 1px solid #b3e5fc;
    background: #e1f5fe;
    color: #01579b;
    font-size: 12px;
    font-weight: 700;
  }
  .mas-loading {
    text-align: center;
    padding: 36px 12px;
    color: #0277bd;
    font-size: 13px;
    font-weight: 600;
  }
  .mas-loading__spinner {
    width: 28px;
    height: 28px;
    margin: 0 auto 10px;
    border-radius: 999px;
    border: 3px solid #b3e5fc;
    border-top-color: #0288d1;
    animation: mas-spin 0.7s linear infinite;
  }
  @keyframes mas-spin {
    to { transform: rotate(360deg); }
  }
  .mas-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    min-height: 36px;
    padding: 6px 14px;
    border-radius: 8px;
    font-size: 13px;
    font-weight: 800;
    border: 2px solid transparent;
    cursor: pointer;
  }
  .mas-btn:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }
  .mas-btn--ghost {
    background: #fff;
    border-color: #b3e5fc;
    color: #0277bd;
  }
  .mas-btn--ghost:hover:not(:disabled) {
    background: #e1f5fe;
  }
  .mas-btn--primary {
    background: linear-gradient(135deg, #03a9f4 0%, #0288d1 100%);
    border-color: #0288d1;
    color: #fff;
  }
  .mas-btn--primary:hover:not(:disabled) {
    filter: brightness(1.03);
  }
`;

const MdlAddExamClassSubject = ({
  show,
  onHide,
  examId,
  sessionId,
  classId,
  className,
  sectionId = "No",
  mClassList = [],
  onSave,
}) => {
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [availableSubjects, setAvailableSubjects] = useState([]);
  const [selectedSubjectId, setSelectedSubjectId] = useState("");
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    if (!show) return undefined;
    const styleTag = document.createElement("style");
    styleTag.setAttribute("data-mdl-add-subject", "1");
    styleTag.textContent = DIALOG_STYLES;
    document.head.appendChild(styleTag);
    return () => {
      if (styleTag.parentNode) styleTag.parentNode.removeChild(styleTag);
    };
  }, [show]);

  //Created By Cursor
  const loadClassSubjects = useCallback(async () => {
    if (!classId) {
      setAvailableSubjects([]);
      return;
    }
    if (!sessionId) {
      myToast.notify_error("Session ID is missing. Please refresh the page.");
      return;
    }

    setLoading(true);
    const schoolCode = SessionManager.getSchoolCode();

    try {
      const response = await axios.get(`${API_BASE()}getClassSubject.php`, {
        params: {
          school_code: schoolCode,
          class_id: classId,
          section_id: sectionId,
          session_id: sessionId,
        },
      });

      if (response.data?.api_status === "OK") {
        const allSubjects = response.data.data || [];
        const currentSectionId = sectionId || "No";
        const alreadyAddedIds = [];

        mClassList.forEach((classItem) => {
          const itemSectionId = classItem.section_id || "No";
          const classMatches =
            String(classItem.class_id) === String(classId);
          const sectionMatches =
            String(itemSectionId) === String(currentSectionId);

          if (
            classMatches &&
            sectionMatches &&
            Array.isArray(classItem.subject)
          ) {
            alreadyAddedIds.push(
              ...classItem.subject.map((subj) => subj.subject_id)
            );
          }
        });

        const available = allSubjects.filter(
          (subject) => !alreadyAddedIds.includes(subject.subject_id)
        );
        setAvailableSubjects(available);
      } else {
        myToast.notify_warning(
          response.data?.api_remark || "Failed to load subjects"
        );
        setAvailableSubjects([]);
      }
    } catch (error) {
      console.error("Error loading subjects:", error);
      myToast.notify_error("Error loading subjects");
      setAvailableSubjects([]);
    } finally {
      setLoading(false);
    }
  }, [classId, sectionId, sessionId, mClassList]);

  useEffect(() => {
    if (!show) return;
    setSelectedSubjectId("");
    setSearchTerm("");
    if (classId) {
      loadClassSubjects();
    } else {
      setAvailableSubjects([]);
    }
  }, [show, classId, loadClassSubjects]);

  const filteredSubjects = useMemo(() => {
    const q = searchTerm.trim().toLowerCase();
    if (!q) return availableSubjects;
    return availableSubjects.filter((subject) => {
      const hay = [subject.subject_name, subject.subject_code, subject.subject_id]
        .filter(Boolean)
        .join(" ")
        .toLowerCase();
      return hay.includes(q);
    });
  }, [availableSubjects, searchTerm]);

  const selectedSubject = useMemo(
    () =>
      availableSubjects.find(
        (subject) => String(subject.subject_id) === String(selectedSubjectId)
      ) || null,
    [availableSubjects, selectedSubjectId]
  );

  //Created By Cursor
  const handleClose = useCallback(() => {
    setSelectedSubjectId("");
    setAvailableSubjects([]);
    setSearchTerm("");
    setLoading(false);
    setSaving(false);
    onHide();
  }, [onHide]);

  //Created By Cursor
  const handleSave = useCallback(async () => {
    if (!classId) {
      myToast.notify_error("No class selected");
      return;
    }
    if (!selectedSubjectId) {
      myToast.notify_warning("Please select a subject");
      return;
    }

    setSaving(true);
    const schoolCode = SessionManager.getSchoolCode();
    const staffId = SessionManager.getStaffDetails()?.staff_id || "";

    try {
      const response = await axios.get(`${API_BASE()}AddSubjectInExam.php`, {
        params: {
          staff_id: staffId,
          exam_id: examId,
          class_id: classId,
          section_id: sectionId,
          subject_id: selectedSubjectId,
          school_code: schoolCode,
        },
      });

      if (response.data?.api_status === "OK") {
        myToast.notify_success("Subject added to exam successfully!");
        if (typeof onSave === "function") {
          onSave({
            class: { class_id: classId, class_name: className },
            subject: { subject_id: selectedSubjectId },
            classId,
            subjectId: selectedSubjectId,
          });
        }
        handleClose();
      } else {
        myToast.notify_error(
          response.data?.api_remark || "Failed to add subject to exam"
        );
      }
    } catch (error) {
      console.error("Error adding subject to exam:", error);
      myToast.notify_error("Error adding subject to exam");
    } finally {
      setSaving(false);
    }
  }, [
    classId,
    className,
    examId,
    handleClose,
    onSave,
    sectionId,
    selectedSubjectId,
  ]);

  if (!show) return null;

  const busy = loading || saving;

  return (
    <Modal
      show={show}
      onHide={handleClose}
      animation={false}
      centered
      dialogClassName="mdl-add-subject-dialog"
      aria-labelledby="mdl-add-subject-title"
    >
      <Modal.Header closeButton={!busy}>
        <div className="mas-title" id="mdl-add-subject-title">
          <span className="mas-title__icon" aria-hidden>
            <FaBookOpen />
          </span>
          <div className="mas-title__text">
            <div className="mas-title__main">Add Subject</div>
            <div className="mas-title__sub">
              Choose a subject for {className || "this class"}
            </div>
          </div>
        </div>
      </Modal.Header>

      <Modal.Body>
        <div className="mas-meta">
          <span className="mas-pill">
            Class: <strong>{className || "—"}</strong>
          </span>
          <span className="mas-pill">
            Available: <strong>{availableSubjects.length}</strong>
          </span>
        </div>

        {loading ? (
          <div className="mas-loading">
            <div className="mas-loading__spinner" aria-hidden />
            Loading subjects…
          </div>
        ) : (
          <>
            <div className="mas-search">
              <FaSearch aria-hidden />
              <input
                type="search"
                placeholder="Search subjects…"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                aria-label="Search subjects"
                disabled={busy}
              />
            </div>

            {filteredSubjects.length > 0 ? (
              <div className="mas-list" role="listbox" aria-label="Subjects">
                {filteredSubjects.map((subject, index) => {
                  const active =
                    String(selectedSubjectId) === String(subject.subject_id);
                  return (
                    <button
                      key={subject.subject_id || index}
                      type="button"
                      role="option"
                      aria-selected={active}
                      className={`mas-item${active ? " is-active" : ""}`}
                      onClick={() => setSelectedSubjectId(subject.subject_id)}
                      disabled={busy}
                    >
                      <span className="mas-item__check" aria-hidden>
                        <FaCheck />
                      </span>
                      <span className="mas-item__body">
                        <span className="mas-item__name">
                          {subject.subject_name}
                        </span>
                        {subject.subject_code ? (
                          <span className="mas-item__code">
                            Code: {subject.subject_code}
                          </span>
                        ) : null}
                      </span>
                    </button>
                  );
                })}
              </div>
            ) : (
              <div className="mas-empty">
                <p className="mas-empty__title">
                  {availableSubjects.length === 0
                    ? "No subjects available"
                    : "No matches"}
                </p>
                <p className="mas-empty__hint">
                  {availableSubjects.length === 0
                    ? "All class subjects may already be added to this exam."
                    : "Try a different search term."}
                </p>
              </div>
            )}

            {selectedSubject ? (
              <div className="mas-selected">
                Selected: {selectedSubject.subject_name}
              </div>
            ) : null}
          </>
        )}
      </Modal.Body>

      <Modal.Footer>
        <button
          type="button"
          className="mas-btn mas-btn--ghost"
          onClick={handleClose}
          disabled={busy}
        >
          <FaTimes aria-hidden /> Cancel
        </button>
        <button
          type="button"
          className="mas-btn mas-btn--primary"
          onClick={handleSave}
          disabled={!classId || !selectedSubjectId || busy}
        >
          <FaCheck aria-hidden />
          {saving ? "Adding…" : "Add to Exam"}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default MdlAddExamClassSubject;
